import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const AuthCallback = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');
        const hasCompletedWizard = params.get('hasCompletedWizard') === 'true';

        if (token) {
            localStorage.setItem('authToken', token);
            navigate(hasCompletedWizard ? '/task-manager' : '/wizard');
        } else {
            navigate('/login');
        }
    }, [navigate, location]);

    return (
        <div className="flex justify-center items-center h-screen">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500" />
        </div>
    );
};

export default AuthCallback; 